module.exports = __webpack_public_path__ + "static/media/pfunda_small_toward.6c31e1d7.jpg";